window.Shopify.formatMoney = function(money, format) {
    function n(t, e) {
        return "undefined" == typeof t ? e : t
    }
    function r(t, e, r, i) {
        if (e = n(e, 2),
            r = n(r, ","),
            i = n(i, "."),
        isNaN(t) || null == t)
            return 0;
        t = (t / 100).toFixed(e);
        var o = t.split(".")
            , a = o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + r)
            , s = o[1] ? i + o[1] : "";
        return a + s
    }
    "string" == typeof money && (money = money.replace(".", ""));
    var i = ""
        , o = /\{\{\s*(\w+)\s*\}\}/
        , a = format || window.BOLD.common.Shopify.shop.money_format || window.Shopify.money_format || "$ {{ amount }}";
    switch (a.match(o)[1]) {
        case "amount":
            i = r(money, 2, ",", ".");
            break;
        case "amount_no_decimals":
            i = r(money, 0, ",", ".");
            break;
        case "amount_with_comma_separator":
            i = r(money, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            i = r(money, 0, ".", ",");
            break;
        case "amount_with_space_separator":
            i = r(money, 2, " ", ",");
            break;
        case "amount_no_decimals_with_space_separator":
            i = r(money, 0, " ", ",");
            break;
        case "amount_with_apostrophe_separator":
            i = r(money, 2, "'", ".");
            break;
    }
    return a.replace(o, i);
};

function verifyDiscounts() {
    var tier1_enabled = true;
    var tier2_enabled = false;
    var tier3_enabled = false;

    var tier_messages = {
        "free-shipping": "📦 FREE SHIPPING",
        "gwp": "a 🎁 FREE GIFT",
        "fixed-discount": "a ⭐ $##amount## DISCOUNT",
        "percentage-discount": " a ⭐ ##amount##% DISCOUNT"
    }

    var tier_messages_pre = {
        "free-shipping": " and get ",
        "gwp": " to unlock ",
        "fixed-discount": " to unlock ",
        "percentage-discount": " to unlock "
    }
    
    var tier1_conditions_met = false;
    var tier2_conditions_met = false;
    var tier3_conditions_met = false;

    if(tier1_enabled) {
        var tier1_threshold = "34.99";
        var tier1_type = "free-shipping";
        var tier1_gwp = 0;
        var tier1_fixed_discount = 0;
        var tier1_percentage_discount = 0;
        var tier1_gwp_added = false;
    }

    if(tier2_enabled) {
        var tier2_threshold = "60";
        var tier2_type = "gwp";
        var tier2_gwp = 41218458386632;
        var tier2_fixed_discount = 0;
        var tier2_percentage_discount = 0;
        var tier2_gwp_added = false;
    }

    if(tier3_enabled) {
        var tier3_threshold = "";
        var tier3_type = "free-shipping";
        var tier3_gwp = 0;
        var tier3_fixed_discount = 0;
        var tier3_percentage_discount = 0;
        var tier3_gwp_added = false;
    }

    $.getJSON('/cart.js', function (cart) {
        if(tier1_enabled) {
            if(parseInt(cart.total_price/100) >= tier1_threshold) tier1_conditions_met = true;
        }
        if(tier2_enabled) {
            if(parseInt(cart.total_price/100) >= tier2_threshold) tier2_conditions_met = true;
        }
        if(tier3_enabled) {
            if(parseInt(cart.total_price/100) >= tier3_threshold) tier3_conditions_met = true;
        }

        if(tier1_type == "gwp") {
            if (cart.items.length > 0) {
                for (var i = 0; i < cart.items.length; i++) {
                    if(cart.items[i].id == tier1_gwp && cart.items[i].properties != null && '_gwp_tier1' in cart.items[i].properties) {
                        tier1_gwp_added = true;
                        var tier1_gwp_line_item = i+1;
                    }
                }
            }

            if(tier1_conditions_met && !tier1_gwp_added) {
                addGWP(tier1_gwp,'tier1');
            }

            if(!tier1_conditions_met && tier1_gwp_added) {
                removeGWP(tier1_gwp_line_item);
            }
        }

        if(tier2_type == "gwp") {
            if (cart.items.length > 0) {
                for (var i = 0; i < cart.items.length; i++) {
                    if(cart.items[i].id == tier2_gwp && cart.items[i].properties != null && '_gwp_tier2' in cart.items[i].properties) {
                        tier2_gwp_added = true;
                        var tier2_gwp_line_item = i+1;
                    }
                }
            }

            if(tier2_conditions_met && !tier2_gwp_added) {
                addGWP(tier2_gwp,'tier2');
            }

            if(!tier2_conditions_met && tier2_gwp_added) {
                removeGWP(tier2_gwp_line_item);
            }
        }

        if(tier3_type == "gwp") {
            if (cart.items.length > 0) {
                for (var i = 0; i < cart.items.length; i++) {
                    if(cart.items[i].id == tier3_gwp && cart.items[i].properties != null && '_gwp_tier3' in cart.items[i].properties) {
                        tier3_gwp_added = true;
                        var tier3_gwp_line_item = i+1;
                    }
                }
            }

            if(tier3_conditions_met && !tier3_gwp_added) {
                addGWP(tier3_gwp,'tier3');
            }

            if(!tier3_conditions_met && tier3_gwp_added) {
                removeGWP(tier3_gwp_line_item);
            }
        }

        var total_tiers = 0;
        var completed_tiers = 0;
        
        if(tier3_enabled) {
            total_tiers += 1;

            var tier3_discount = 0;
            if(tier3_type == "fixed-discount") tier3_discount = tier3_fixed_discount;
            if(tier3_type == "percentage-discount") tier3_discount = tier3_percentage_discount;

            $('.tiered-discounts h4').text('Spend $'+tier3_threshold+tier_messages_pre[tier3_type]+tier_messages[tier3_type].replace("##amount##",tier3_discount));

            if(!tier3_conditions_met) {
                var percentage_completed = parseInt(cart.total_price/100) * 100 / tier3_threshold;
                $('.tiered-discounts .bar span').css({"width": percentage_completed + "%"});
            } else {
                $('.tiered-discounts .bar span').css({"width": "100%"});
                if(tier3_discount != 0) {
                    $('.cart-summary-total').html('<span class="line-through">'+window.Shopify.formatMoney(cart.original_total_price, $('body').data('money-format'))+'</span> ' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')))
                    if(tier3_type == "fixed-discount") $('.cart-summary-total').append('<div class="subtotal-discount">YOU\'VE EARNED $'+tier3_discount+' OFF!</div>');
                    if(tier3_type == "percentage-discount") $('.cart-summary-total').append('<div class="subtotal-discount">YOU\'VE EARNED '+tier3_discount+'% OFF!</div>');
                }
                completed_tiers += 1;
            }
        }
        
        if(tier2_enabled) {
            total_tiers += 1;
            var tier2_discount = 0;
            if(tier2_type == "fixed-discount") tier2_discount = tier2_fixed_discount;
            if(tier2_type == "percentage-discount") tier2_discount = tier2_percentage_discount;

            if(!tier2_conditions_met) {
                var percentage_completed = parseInt(cart.total_price/100) * 100 / tier2_threshold;
                $('.tiered-discounts .bar span').css({"width": percentage_completed + "%"});    
                $('.tiered-discounts h4').text('Spend $'+tier2_threshold+tier_messages_pre[tier2_type]+tier_messages[tier2_type].replace("##amount##",tier2_discount));
            } else {
                completed_tiers += 1;
                if(tier2_discount != 0) {
                    $('.cart-summary-total').html('<span class="line-through">'+window.Shopify.formatMoney(cart.original_total_price, $('body').data('money-format'))+'</span> ' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')))
                    if(tier2_type == "fixed-discount") $('.cart-summary-total').append('<div class="subtotal-discount">YOU\'VE EARNED $'+tier2_discount+' OFF!</div>');
                    if(tier2_type == "percentage-discount") $('.cart-summary-total').append('<div class="subtotal-discount">YOU\'VE EARNED '+tier2_discount+'% OFF!</div>');
                }

                if(!tier3_enabled) {
                    $('.tiered-discounts .bar span').css({"width": "100%"});
                    $('.tiered-discounts h4').text('Spend $'+tier2_threshold+tier_messages_pre[tier2_type]+tier_messages[tier2_type].replace("##amount##",tier2_discount));
                }
            }
        } 

        if(tier1_enabled) {            
            total_tiers += 1;
            var tier1_discount = 0;
            if(tier1_type == "fixed-discount") tier1_discount = tier1_fixed_discount;
            if(tier1_type == "percentage-discount") tier1_discount = tier1_percentage_discount;

            if(!tier1_conditions_met) {
                var percentage_completed = parseInt(cart.total_price/100) * 100 / tier1_threshold;
                $('.tiered-discounts .bar span').css({"width": percentage_completed + "%"});
                $('.tiered-discounts h4').text('Spend $'+tier1_threshold+tier_messages_pre[tier1_type]+tier_messages[tier1_type].replace("##amount##",tier1_discount));
            } else {
                completed_tiers += 1;
                if(tier1_discount != 0) {
                    $('.cart-summary-total').html('<span class="line-through">'+window.Shopify.formatMoney(cart.original_total_price, $('body').data('money-format'))+'</span> ' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')))
                    if(tier1_type == "fixed-discount") $('.cart-summary-total').append('<div class="subtotal-discount">YOU\'VE EARNED $'+tier1_discount+' OFF!</div>');
                    if(tier1_type == "percentage-discount") $('.cart-summary-total').append('<div class="subtotal-discount">YOU\'VE EARNED '+tier1_discount+'% OFF!</div>');
                }
                if(!tier2_enabled) {
                    $('.tiered-discounts .bar span').css({"width": "100%"});
                    $('.tiered-discounts h4').text('Spend $'+tier1_threshold+tier_messages_pre[tier1_type]+tier_messages[tier1_type].replace("##amount##",tier1_discount));
                }
            }
        }

        if(total_tiers > 0 && completed_tiers == total_tiers) {
            $('.tiered-discounts').addClass('completed');
            $('.tiered-discounts-partially-completed').removeClass('show');

            if(tier1_conditions_met && !tier2_enabled && !tier3_enabled) {               
                $('.tiered-discounts h4').html('<strong>Congratulations! You’ve unlocked '+tier_messages[tier1_type].replace("##amount##",tier1_discount)+'!</strong>');
            } else if(tier1_conditions_met && tier2_conditions_met && !tier3_enabled) {
                $('.tiered-discounts h4').html('<strong>Congratulations! You’ve unlocked '+tier_messages[tier2_type].replace("##amount##",tier2_discount)+'!</strong>');
                $('.tiered-discounts h5').html('Along with '+tier_messages[tier1_type].replace("##amount##",tier1_discount)+'!');
            } else if(tier1_conditions_met && tier2_conditions_met && tier3_conditions_met) {
                $('.tiered-discounts h4').html('<strong>Congratulations! You’ve unlocked '+tier_messages[tier3_type].replace("##amount##",tier3_discount)+'!</strong>');
                $('.tiered-discounts h5').html('Along with '+tier_messages[tier1_type].replace("##amount##",tier1_discount)+' and '+tier_messages[tier2_type].replace("##amount##",tier2_discount)+'!');
            }
        } else if(total_tiers > 0 && completed_tiers > 0 && completed_tiers < total_tiers) {
            $('.tiered-discounts-partially-completed').addClass('show');
            if(tier1_conditions_met && !tier2_conditions_met && !tier3_conditions_met) {                   
                $('.tiered-discounts-partially-completed').text('You have unlocked '+tier_messages[tier1_type].replace("##amount##",tier1_discount)+'!');
            } else if(tier1_conditions_met && tier2_conditions_met && !tier3_conditions_met) {
                $('.tiered-discounts-partially-completed').html('You have unlocked '+tier_messages[tier1_type].replace("##amount##",tier1_discount)+'<br/> & '+tier_messages[tier2_type].replace("##amount##",tier2_discount)+' !');
            }
            
            $('.tiered-discounts').removeClass('completed');
        } else {            

            $('.tiered-discounts-partially-completed').removeClass('show');
            $('.tiered-discounts').removeClass('completed');
        }
    });
}

verifyDiscounts();

$('body').on('updated-mini-cart', function() {
    verifyDiscounts();
});

function addGWP(id,tier) {
    if(sessionStorage.getItem('remove-gwp-free-product') == null || sessionStorage.getItem('remove-gwp-free-product') != id) {
        var propertiesKey = '_gwp_'+tier;
        let properties = {};
        properties[propertiesKey] = 'true';

        let items = [
        {
            quantity: 1,
            id: id,
            properties: properties
        }
        ];
        $.post('/cart/add.js', {
            items: items
        }).always(function () {
            if ($('body').hasClass('cart')) location.reload();
            else $('body').trigger('cart-content-updated');
        });
    } else {
        return false;
    }
}

function removeGWP(line) {
    let items = {
        quantity: 0,
        line: line
    };
    $.post('/cart/change.js', items).always(function () {
        if ($('body').hasClass('cart')) location.reload();
        else $('body').trigger('cart-content-updated');
    });
}

$('body').on('click', 'a.remove-gwp-on-purpose', function(e) {
    e.preventDefault();

    removeGWPOnPurpose($(this).data('line'),$(this).data('variant'))
})

function removeGWPOnPurpose(line, variant) {
    let items = {
        quantity: 0,
        line: line
    };
    $.post('/cart/change.js', items).always(function () {
        sessionStorage.setItem('remove-gwp-free-product', variant);
        sessionStorage.setItem('gwp-added-to-cart', 'false');
        if ($('body').hasClass('cart')) location.reload();
        else $('body').trigger('cart-content-updated');
    });
}